import dicomParser from 'dicom-parser';
import { CHANNEL_BASELINE, CHANNEL_DEFINITION_SEQUENCE, CHANNEL_DEFINITION_START_TAG, CHANNEL_SENSITIVITY, CHANNEL_SENSITIVITY_CORRECTION_FACTOR, CHANNEL_SENSITIVITY_UNITS, CHANNEL_SOURCE, CODE_MEANING, CODE_VALUE, CODING_SCHEME_DESIGNATOR, CODING_SCHEME_VERSION, MULTIPLEX_GROUP_LABEL, NUMBER_OF_WAVEFORM_CHANNELS, NUMBER_OF_WAVEFORM_SAMPLES, PATIENT_ID, SAMPLING_FREQUENCY, SOP_CLASS_UID, WAVEFORM_BITS_ALLOCATED, WAVEFORM_BITS_STORED, WAVEFORM_ORIGINALITY, WAVEFORM_SAMPLE_INTERPRETATION, WAVEFORM_SEQUENCE, } from '../constants';
/**
 * Read the arraydicombuffer and return dataSet.
 * @param dataDICOMarrayBuffer
 * @returns dataSet.
 */
export var getDataSet = function (dataDICOMarrayBuffer) {
    return dicomParser.parseDicom(new Uint8Array(dataDICOMarrayBuffer));
};
/**
 * Helper function to read sequences of coded elements, like:
 * - Channel Source Sequence (003A,0208)
 * - Channel Sensitivity Units Sequence (003A,0211)
 */
export var readCodeSequence = function (codeSequence) {
    var _a;
    var code = {};
    if (!(codeSequence === null || codeSequence === void 0 ? void 0 : codeSequence.items) || !((_a = codeSequence === null || codeSequence === void 0 ? void 0 : codeSequence.items) === null || _a === void 0 ? void 0 : _a.length))
        return code;
    var codeDataset = codeSequence.items[0].dataSet;
    if (!codeDataset)
        return code;
    code.codeValue = codeDataset.string(CODE_VALUE); // VR = SH
    code.codingSchemeDesignator = codeDataset.string(CODING_SCHEME_DESIGNATOR); // VR = SH
    code.codingSchemeVersion = codeDataset.string(CODING_SCHEME_VERSION); // VR = SH
    code.codeMeaning = codeDataset.string(CODE_MEANING); // VR = LO
    return code;
};
/**
 * Read and return ECG Data.
 * Structure: Waveform - Multiplex - channels - sample
 * @param dataSet
 * @returns MultiplexGroup.
 */
export var readData = function (dataSet) {
    var _a, _b;
    // MultiplexGroup:
    var mg = {
        sopClassUID: '',
        patientID: '',
        waveformOriginality: '',
        numberOfWaveformChannels: 0,
        numberOfWaveformSamples: 0,
        samplingFrequency: 0.0,
        multiplexGroupLabel: '',
        waveformBitsAllocated: 0,
        waveformSampleInterpretation: '',
    };
    var waveformSequence = dataSet.elements[WAVEFORM_SEQUENCE];
    if (!waveformSequence)
        return mg;
    //Read patient information:
    mg.sopClassUID = dataSet.string(SOP_CLASS_UID); //UID.
    mg.patientID = dataSet.string(PATIENT_ID); // LO = Patient id.
    var waveformDataIsPresent = ((_a = waveformSequence === null || waveformSequence === void 0 ? void 0 : waveformSequence.items) === null || _a === void 0 ? void 0 : _a.length) || 0 > 0;
    if (!waveformDataIsPresent)
        return mg;
    (_b = waveformSequence.items) === null || _b === void 0 ? void 0 : _b.forEach(function (item) {
        var _a, _b;
        if (item.tag !== CHANNEL_DEFINITION_START_TAG)
            return;
        // Item start tag
        var multiplexGroup = item.dataSet;
        if (!multiplexGroup)
            return;
        mg.waveformOriginality = multiplexGroup.string(WAVEFORM_ORIGINALITY); // VR = CS
        mg.numberOfWaveformChannels = multiplexGroup.uint16(NUMBER_OF_WAVEFORM_CHANNELS); // VR = US
        mg.numberOfWaveformSamples = multiplexGroup.uint32(NUMBER_OF_WAVEFORM_SAMPLES); // VR = UL
        mg.samplingFrequency = multiplexGroup.floatString(SAMPLING_FREQUENCY); // VR = DS
        mg.multiplexGroupLabel = multiplexGroup.string(MULTIPLEX_GROUP_LABEL); // VR = SH
        // Initialization of channels
        var channelDefinitionSequence = multiplexGroup.elements[CHANNEL_DEFINITION_SEQUENCE];
        var channelDefinitionSequenceIsPresent = ((_a = channelDefinitionSequence === null || channelDefinitionSequence === void 0 ? void 0 : channelDefinitionSequence.items) === null || _a === void 0 ? void 0 : _a.length) || 0 > 0;
        if (channelDefinitionSequence !== undefined && channelDefinitionSequenceIsPresent) {
            (_b = channelDefinitionSequence === null || channelDefinitionSequence === void 0 ? void 0 : channelDefinitionSequence.items) === null || _b === void 0 ? void 0 : _b.forEach(function (item) {
                // Item start tag
                if (item.tag !== CHANNEL_DEFINITION_START_TAG)
                    return;
                var channelDefinition = item.dataSet;
                var cd = {};
                if (!channelDefinition)
                    return;
                cd.channelSource = readCodeSequence(channelDefinition.elements[CHANNEL_SOURCE]);
                // Getting sensitive stats http://stackoverflow.com/questions/12855400/rchannel-sensitivity-in-dicom-waveforms
                cd.channelSensitivity = channelDefinition.string(CHANNEL_SENSITIVITY); // VR = DS
                cd.channelSensitivityUnits = readCodeSequence(channelDefinition.elements[CHANNEL_SENSITIVITY_UNITS]);
                cd.channelSensitivityCorrectionFactor = channelDefinition.string(CHANNEL_SENSITIVITY_CORRECTION_FACTOR); // VR = DS
                cd.channelBaseline = channelDefinition.string(CHANNEL_BASELINE); // VR = DS
                cd.waveformBitsStored = channelDefinition.uint16(WAVEFORM_BITS_STORED); // VR = US
            });
        }
        mg.waveformBitsAllocated = multiplexGroup.uint16(WAVEFORM_BITS_ALLOCATED); // VR = US
        mg.waveformSampleInterpretation = multiplexGroup.string(WAVEFORM_SAMPLE_INTERPRETATION); // VR = CS
        var waveSampleIsSigned = mg.waveformSampleInterpretation === 'SS';
        var waveIs16BitLinearSigned = mg.waveformBitsAllocated === 16;
        if (!waveSampleIsSigned || !waveIs16BitLinearSigned)
            return;
    });
    return mg;
};
//# sourceMappingURL=ReadECGData.js.map